import React, { useState } from 'react'
import {Alert, Button, TextField} from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom';
import { authenticate } from '../services/authenticate';
import {MoveUserPool, ViewUserPool} from "../userpool";


const Login = () => {

  const Navigate = useNavigate();
  const location = useLocation();

  const [username, setUsername] = useState('+972-');
  const [password, setPassword] = useState('');
  const [usernameErr, setUsernameErr] = useState('');
  const [passwordErr, setPasswordErr] = useState('');
  const [loginErr,setLoginErr]=useState('');

  const formInputChange = (formField, value) => {
    if (formField === "username") {
      setUsername(value);
    }
    if (formField === "password") {
      setPassword(value);
    }
  };

  const validation = () => {
    return new Promise((resolve, reject) => {
      if (username === '' && password === '') {
        setUsernameErr("Phone number is Required");
        setPasswordErr("Password is required")
        resolve({ username: "Phone number is Required", password: "Password is required" });
      }
      else if (username === '') {
        setUsernameErr("Phone number is Required")
        resolve({ username: "Phone number is Required", password: "" });
      }
      else if (password === '') {
        setPasswordErr("Password is required")
        resolve({ username: "", password: "Password is required" });
      }
      else if (password.length < 8) {
        setPasswordErr("must be at least 8 character")
        resolve({ username: "", password: "must be 8 character" });
      }
      else {
        resolve({ username: "", password: "" });
      }
    });
  };

  const handleClick = () => {
    setUsernameErr("");
    setPasswordErr("");
    validation()
      .then((res) => {
        if (res.username === '' && res.password === '') {
          const trimmedUsername = username.replaceAll("-", "")
          let userpool;
          let navigateTo = "";
          if (location.state && location.state.from === "view") {
            userpool = ViewUserPool;
            navigateTo = "/view";
          } else if (location.state && location.state.from === "fast") {
            userpool = MoveUserPool;
            navigateTo = "/fast";
          }
          else {
            userpool = MoveUserPool;
            navigateTo = "/link";
          }
          authenticate(trimmedUsername, password, userpool)
          .then((data)=>{
            setLoginErr('');
            Navigate(navigateTo);
          },(err)=>{
            console.log(err);
            setLoginErr(err.message)
          })
          .catch(err=>console.log(err))
        }
      }, err => console.log(err))
      .catch(err => console.log(err));
  }

  return (
    <div className="login">
      <img className="logo" src="logo.png" alt="Logo" width="200" height="100"/>
      <div className='login_form'>
        <div className="formfield">
          <TextField
            value={username}
            onChange={(e) => formInputChange("username", e.target.value)}
            label="Phone number"
            helperText={usernameErr}
            placeholder={"+972-5X-1111111"}
          />
        </div>
        <div className='formfield'>
          <TextField
            value={password}
            onChange={(e) => { formInputChange("password", e.target.value) }}
            type="password"
            label="Password"
            helperText={passwordErr}
          />
        </div>
        <div className='formfield formFieldCentered'>
          <Button className="loginButton" type='submit' variant='contained' onClick={handleClick}>Login</Button>
        </div>
        {loginErr && <Alert severity="error">{loginErr}</Alert>}
      </div>

    </div>
  )
}

export default Login